import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

const Line = styled.hr`
  border: none;
  background-color: ${theme.colors.gray100};

  &.vertical {
    position: relative;
    top: -1;
    display: inline-block;
    width: 2px;
    height: 13px;
    vertical-align: middle;
  }

  &.horizontal {
    display: block;
    width: 100%;
    height: 2px;
  }
`;

const Divider = ({ direction, marginSize, ...props }) => {
  const dividerStyle = {
    margin: direction === 'vertical' ? `0 ${marginSize}` : `${marginSize} 0`,
  };
  return (
    <Line
      {...props}
      className={direction}
      style={{ ...dividerStyle, ...props.style }}
    />
  );
};

Divider.propTypes = {
  direction: PropTypes.string,
  marginSize: PropTypes.string,
  style: PropTypes.object,
};

Divider.defaultProps = {
  direction: 'horizontal',
  marginSize: theme.spacing.m,
  style: {},
};

export default Divider;
